const FEATUREBASE_JWT_ENDPOINT =
  'https://griply.featurebase.app/api/v1/auth/access/jwt';

export const constructFeaturebaseJwtUrl = (
  jwtToken: string,
  returnToUrl: string,
): string => {
  const query = `jwt=${encodeURIComponent(jwtToken)}&return_to=${encodeURIComponent(returnToUrl)}`;

  return `${FEATUREBASE_JWT_ENDPOINT}?${query}`;
};
